import { APP_STORE_URLS } from '@splitfiesta/shared';

export interface StorePlatform {
  url: string;
  available: boolean;
}

export interface AppStoreConfig {
  ios: StorePlatform;
  android: StorePlatform;
  anyAvailable: boolean;
}

/**
 * Combines the shared store URLs with per-platform availability flags.
 * Flags default to off so buttons ship dark until each store is public:
 *   - VITE_APP_STORE_AVAILABLE  → iOS App Store listing is live
 *   - VITE_PLAY_STORE_AVAILABLE → Google Play listing is live (also gates
 *     the NativeAppPrompt banner — one Android flag, not two)
 */
export function getAppStoreConfig(): AppStoreConfig {
  const ios: StorePlatform = {
    url: APP_STORE_URLS.ios,
    available: import.meta.env.VITE_APP_STORE_AVAILABLE === 'true',
  };
  const android: StorePlatform = {
    url: APP_STORE_URLS.android,
    available: import.meta.env.VITE_PLAY_STORE_AVAILABLE === 'true',
  };
  return { ios, android, anyAvailable: ios.available || android.available };
}
